import { useState } from 'react';
import { AttachFile, UploadFile } from "@mui/icons-material";
import { Button, Grid, Paper, Typography, Dialog, DialogActions, DialogContent, DialogTitle, TextField, CircularProgress, Box } from "@mui/material";
import { useSnackbar } from "notistack";
import { uploadData } from 'aws-amplify/storage';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

export default function Controle({ n_solicitacao, status, onUpdate, email }: any) {
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
    const [motivo, setMotivo] = useState('');
    const [loadingAceite, setLoadingAceite] = useState(false)
    const [loadingRejeicao, setLoadingRejeicao] = useState(false)
    const [openModalAditivo, setOpenModalAditivo] = useState(false)
    const [fileAditivo, setFileAditivo] = useState<File | null>(null)
    const [openModalRelatorio, setOpenModalRelatorio] = useState(false)
    const [fileRelatorio, setFileRelatorio] = useState<File | null>(null)

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleOpenModalAditivo = () => {
        setOpenModalAditivo(true)
    }
    const handleCloseModalAditivo = () => {
        setOpenModalAditivo(false)
    }

    const handleOpenModalRelatorio = () => {
        setOpenModalRelatorio(true)
    }
    const handleCloseModalRelatorio = () => {
        setOpenModalRelatorio(false)
    }

    const handleChangeFileAditivo = (event: any) => {
        setFileAditivo(event.target.files[0])
    }

    const handleChangeFileRelatorio = (event: any) => {
        setFileRelatorio(event.target.files[0])
    }

    const handleAceite = async () => {
        setLoadingAceite(true)
        try {
            const dataAprovacao = new Date().toISOString().split('T')[0];

            await onUpdate({
                status: 2,
                data_aprovacao: dataAprovacao
            });

            enqueueSnackbar('Solicitação aceita!', { variant: 'success' });

            const emailData = {
                subject: `Solicitação ${n_solicitacao} aceita`,
                body: `
                A sua solicitação ${n_solicitacao} foi aceita pelo Laboratório Químico! 
                Acesse a plataforma para mais informações.`,
                recipient: `${email}`, 
            };
            
            try {
                const session = await fetchAuthSession()
                const token = session.tokens?.idToken
                const emailResponse = await axios.post('https://5n2t581gd4.execute-api.us-east-2.amazonaws.com/prod', emailData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });
                console.log('E-mail enviado:', emailResponse.data);
            } catch (error) {
                console.error('Erro ao enviar e-mail:', error);
            } 
        } catch (error) {
            enqueueSnackbar('Ocorreu um erro ao aceitar a solicitação.', { variant: 'error' });
        } finally {
            setLoadingAceite(false)
        }
    };

    const handleRejeitar = async () => {
        setLoadingRejeicao(true);
        try {
            await onUpdate({
                status: 999,
                motivo_rejeicao: motivo
            });

            const emailData = {
                subject: `Solicitação ${n_solicitacao} recusada`,
                body: `
                Olá,
                A sua solicitação ${n_solicitacao} foi recusada pelo Laboratório Químico.
                Motivo: ${motivo}.
                Acesse a plataforma para realizar a correção necessária e reenviar a solicitação.
                `,
                recipient: `${email}`,
            };
            
            try {
                const session = await fetchAuthSession()
                const token = session.tokens?.idToken
                const emailResponse = await axios.post('https://5n2t581gd4.execute-api.us-east-2.amazonaws.com/prod', emailData, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });
                console.log('E-mail enviado:', emailResponse.data);
            } catch (error) {
                console.error('Erro ao enviar e-mail:', error);
            }

            handleClose();
            enqueueSnackbar('Solicitação recusada', { variant: 'warning' });
        } catch (error) {
            enqueueSnackbar('Ocorreu um erro ao recusar a solicitação.', { variant: 'warning' });
        } finally {
            setLoadingRejeicao(false);
        }
    };

    const handleUploadAditivo = async () => {
        let fileUrl = '';
    
        try {
            if (fileAditivo) {
                // Sanitização silenciosa
                const safeName = fileAditivo.name
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^\w.-]/g, '');

                // Tenta realizar o upload do arquivo
                const result = await uploadData({
                    path: `termoAditivo/${safeName}`,
                    data: fileAditivo
                }).result;
                console.log('Arquivo enviado com sucesso', result);
                fileUrl = result.path || `termoAditivo/${safeName}`;
    
                // Tenta atualizar o banco de dados com o URL do arquivo
                await onUpdate({
                    arquivo_aditivo: fileUrl
                });

                const emailData = {
                    subject: `${n_solicitacao} - Termo Aditivo`,
                    body: `
                    Olá,
                    O Termo Aditivo da solicitação ${n_solicitacao} foi enviado. Acesse a plataforma para visualizar.
                    `,
                    recipient: `${email}`,
                };
                
                try {
                    const session = await fetchAuthSession()
                    const token = session.tokens?.idToken
                    const emailResponse = await axios.post('https://5n2t581gd4.execute-api.us-east-2.amazonaws.com/prod', emailData, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                        }
                    });
                    console.log('E-mail enviado:', emailResponse.data);
                } catch (error) {
                    console.error('Erro ao enviar e-mail:', error);
                    enqueueSnackbar('Relatório enviado, mas houve uma falha ao notificar por e-mail.', { variant: 'warning' });
                }
    
                // Fecha o modal e mostra mensagem de sucesso
                handleCloseModalAditivo();
                enqueueSnackbar('Termo aditivo enviado!', { variant: 'success' });
            } else {
                enqueueSnackbar('Nenhum arquivo selecionado.', { variant: 'warning' });
            }
        } catch (error) {
            console.error('Erro ao enviar o termo aditivo', error);
    
            // Exibe uma mensagem de erro ao usuário
            enqueueSnackbar('Falha ao enviar o termo aditivo. Tente novamente.', { variant: 'error' });
        }
    };

    const handleUploadRelatorio = async () => {
        let fileUrl = ''
        try {
            if (fileRelatorio) {
                // Sanitização silenciosa
                const safeName = fileRelatorio.name
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, '_')
                    .replace(/[^\w.-]/g, '');

                const result = await uploadData({
                    path: `relatorios/${safeName}`,
                    data: fileRelatorio
                }).result;
                console.log('Arquivo enviado com sucesso', result)
                fileUrl = result.path || `relatorios/${safeName}`;

                const dataRelatorio = new Date().toISOString().split('T')[0];

                await onUpdate({
                    status: 4,
                    data_relatorio: dataRelatorio,
                    data_pesquisa: dataRelatorio,
                    arquivo_relatorio: fileUrl
                })

                const emailData = {
                    subject: `${n_solicitacao} - Relatório`,
                    body: `
                    Olá,
                    A solicitação ${n_solicitacao} foi concluída. 
                    Acesse a plataforma para visualizar o relatório e responder à pesquisa de satisfação!.
                    `,
                    recipient: `${email}`,
                };
                
                try {
                    const session = await fetchAuthSession()
                    const token = session.tokens?.idToken
                    const emailResponse = await axios.post('https://5n2t581gd4.execute-api.us-east-2.amazonaws.com/prod', emailData, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                        }
                    });
                    console.log('E-mail enviado:', emailResponse.data);
                } catch (error) {
                    console.error('Erro ao enviar e-mail:', error);
                    enqueueSnackbar('Relatório enviado, mas houve uma falha ao notificar por e-mail.', { variant: 'warning' });
                }

                handleCloseModalRelatorio()
                enqueueSnackbar('Relatório enviado!', { variant: 'success' });
            } else {
                enqueueSnackbar('Nenhum arquivo selecionado.', { variant: 'warning' });
            }
        } catch (error) {
            enqueueSnackbar('Ocorreu um erro ao enviar o relatório!', { variant: 'warning' });
        }
    }

    return (
        <>
            <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item xs={6}>
                        <Typography variant="h6" fontWeight={700}>
                            Acompanhamento da solicitação
                        </Typography>
                        <Typography variant="h6">{n_solicitacao}</Typography>
                    </Grid>

                    <Grid container item xs={6} justifyContent="flex-end" spacing={2}>
                        {status === 1 ? (
                            <>
                                <Grid item>
                                    <Button variant="contained" size="medium" color="success" onClick={handleAceite}>
                                    {loadingAceite ? <CircularProgress size={24} color="inherit" /> : 'Aceitar'}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="outlined" size="medium" color="error" onClick={handleOpen}>
                                        Recusar
                                    </Button>
                                </Grid>
                            </>
                        ) : status === 2 ? (
                            <>
                                <Grid item>
                                    <Typography variant="inherit">Termo aditivo</Typography>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        endIcon={<AttachFile style={{ color: '#3860B2' }} />}
                                        style={{ color: '#3860B2', borderColor: '#3860B2' }}
                                        onClick={handleOpenModalAditivo} // Abre o modal ao clicar
                                    >
                                        Anexar arquivo
                                    </Button>

                                    {/* Modal para o upload */}
                                    <Dialog
                                        open={openModalAditivo}
                                        onClose={handleCloseModalAditivo}
                                        maxWidth="sm" // Tamanho máximo do modal
                                        fullWidth // Ocupa a largura total do "maxWidth"
                                        PaperProps={{
                                            style: {
                                                minWidth: '400px', // Largura mínima fixa
                                                minHeight: '250px', // Altura mínima fixa
                                            },
                                        }}
                                    >
                                        <DialogTitle>Anexar Termo Aditivo</DialogTitle>
                                        <DialogContent>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{
                                                    border: '2px dashed #3860B2',
                                                    padding: '20px',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#f9f9f9',
                                                    cursor: 'pointer',
                                                    textAlign: 'center',
                                                    transition: 'background-color 0.3s',
                                                    '&:hover': {
                                                        backgroundColor: '#e0f0ff'
                                                    },
                                                    height: '150px', // Altura fixa do box de upload
                                                }}
                                                onClick={() => document.getElementById('file-upload')?.click()} // Simula o clique no input de arquivo
                                            >
                                                <UploadFile sx={{ fontSize: 48, color: '#3860B2' }} />
                                                <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
                                                    {fileAditivo?.name || 'Clique aqui para anexar'}
                                                </Typography>
                                            </Box>
                                            <input
                                                id="file-upload"
                                                type="file"
                                                hidden
                                                onChange={handleChangeFileAditivo} // Atualiza o estado com o arquivo selecionado
                                            />
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleCloseModalAditivo} size='small' color="primary">
                                                Cancelar
                                            </Button>
                                            <Button onClick={handleUploadAditivo} size='small' color="success" variant='contained' disabled={!fileAditivo}>
                                                Confirmar Upload
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </Grid>

                                <Grid item>
                                    <Typography variant="inherit">Relatório</Typography>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        endIcon={<AttachFile style={{ color: '#3860B2' }} />}
                                        style={{ color: '#3860B2', borderColor: '#3860B2' }}
                                        onClick={handleOpenModalRelatorio} // Abre o modal ao clicar
                                    >
                                        Anexar arquivo
                                    </Button>

                                    {/* Modal para o upload */}
                                    <Dialog
                                        open={openModalRelatorio}
                                        onClose={handleCloseModalRelatorio}
                                        maxWidth="sm" // Tamanho máximo do modal
                                        fullWidth // Ocupa a largura total do "maxWidth"
                                        PaperProps={{
                                            style: {
                                                minWidth: '400px', // Largura mínima fixa
                                                minHeight: '250px', // Altura mínima fixa
                                            },
                                        }}
                                    >
                                        <DialogTitle>Anexar Relatório</DialogTitle>
                                        <DialogContent>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{
                                                    border: '2px dashed #3860B2',
                                                    padding: '20px',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#f9f9f9',
                                                    cursor: 'pointer',
                                                    textAlign: 'center',
                                                    transition: 'background-color 0.3s',
                                                    '&:hover': {
                                                        backgroundColor: '#e0f0ff'
                                                    },
                                                    height: '150px', // Altura fixa do box de upload
                                                }}
                                                onClick={() => document.getElementById('file-upload')?.click()} // Simula o clique no input de arquivo
                                            >
                                                <UploadFile sx={{ fontSize: 48, color: '#3860B2' }} />
                                                <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
                                                    {fileRelatorio?.name || 'Clique aqui para anexar'}
                                                </Typography>
                                            </Box>
                                            <input
                                                id="file-upload"
                                                type="file"
                                                hidden
                                                onChange={handleChangeFileRelatorio} // Atualiza o estado com o arquivo selecionado
                                            />
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleCloseModalRelatorio} size='small' color="primary">
                                                Cancelar
                                            </Button>
                                            <Button onClick={handleUploadRelatorio} size='small' color="success" variant='contained' disabled={!fileRelatorio}>
                                                Confirmar Upload
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </Grid>
                            </>
                        ) : null}
                    </Grid>
                </Grid>
            </Paper>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Recusar Solicitação</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Motivo"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={motivo}
                        onChange={(e) => setMotivo(e.target.value)}
                        style={{ width: '500px' }}
                        required
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant='text' size='small' onClick={handleClose}>Cancelar</Button>
                    <Button variant='contained' size='small' color='error' onClick={handleRejeitar}>
                        {loadingRejeicao ? <CircularProgress size={22} color="inherit" /> : 'Confirmar'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
